export default __webpack_public_path__ + "static/media/dog8.24367b5f.JPG";